<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb
        el-col.pt-5.text-right(:span="15")
          el-button(v-if="user.role == 3 ? true : ops.indexOf('export') > -1" type="primary" size="mini" @click="exportData") 导出
      el-tabs.title(v-model="activeName" @tab-click="handleTabClick")
        el-tab-pane(:label="'确认中('+count1+')'" name="first")
        el-tab-pane(:label="'处理中('+count2+')'" name="second")
        el-tab-pane(:label="'验收中('+count3+')'" name="three")
        el-tab-pane(:label="'评价中('+count4+')'" name="four")
        el-tab-pane(:label="'处理完毕('+count5+')'" name="five")
        el-tab-pane(:label="'终止处理('+count6+')'" name="six")
        el-tab-pane(:label="'全部申请('+count7+')'" name="seven")
    div(style="height:110px")
    el-main.white.pa-3.ma-4
      el-row.py-3(v-if="!flag" type="flex" justify="center")
        el-col(:span="13")
      div(v-else)
        el-row.py-3(type="flex" justify="center")
          el-col(:span="22")
            el-row(type="flex" justify="center" :gutter="10")
              el-col(:span="6")
                el-input.w-100(v-model="list.code" placeholder="申请单号" clearable)
              el-col(:span="6")
                el-input.w-100(v-model="list.mater_name" placeholder="物料名称" clearable)
              el-col(:span="6")
                el-input.w-100(v-model="list.mater_code" placeholder="物料编码" clearable)
              el-col(:span="6")
                el-select.w-100(v-model="list.supplier" filterable remote placeholder="请搜索供应商" :remote-method="getSupplyList" :loading="loadingSupply" clearable)
                  el-option(v-for="item in supply" :key="item.code" :label="item.name" :value="item.code")
              el-col(:span="6")
                el-input.w-100(v-model="list.user" placeholder="反馈人" clearable)
              el-col(:span="6")
                el-select.w-100(
                  v-model="list.buy_org",
                  :filter-method="sourcebuyorg",
                  filterable,
                  placeholder="采购组织",
                  clearable
                )
                  el-option(
                    v-for="item in buyorg",
                    :key="item.pk_org",
                    :label="item.name",
                    :value="item.pk_org"
                  )               
              el-col(:span="6")
                el-select.w-100(
                  v-model="list.stock_org",
                  :filter-method="sourcestockorg",
                  filterable,
                  placeholder="需求组织",
                  clearable
                )
                  el-option(
                    v-for="item in stockorg",
                    :key="item.pk_org",
                    :label="item.name",
                    :value="item.pk_org"
                  )  
        el-row.py-1(type="flex" justify="center")
          el-col(:span="12")
            el-row(type="flex" justify="center")
              el-col(:span="10")
                el-button(type="primary" @click="search" :loading="loading") 查询
                el-button(@click="clear") 清空
      el-table(:data="data" v-loading="loading" row-key="id" size="mini"  tooltip-effect="dark")
        el-table-column(prop="code" label="申请单号" width="140" key="code" show-overflow-tooltip)
        el-table-column(prop="user_name" label="反馈人" width="100" key="user_name" show-overflow-tooltip)
        el-table-column(prop="user_phone" label="反馈人电话" min-width="120" key="user_phone" show-overflow-tooltip)
        el-table-column(prop="question" label="反馈内容" width="120" key="question" show-overflow-tooltip)
        el-table-column(prop="create_date" label="反馈日期" width="140" key="create_date" show-overflow-tooltip)
        el-table-column(prop="mater_name" label="物料名称" min-width="120" key="mater_name" show-overflow-tooltip)
        el-table-column(prop="supplier_name" label="供应商" width="100" key="supplier_name" show-overflow-tooltip)
        el-table-column(prop="buy_person_name" label="采购员" width="100" key="buy_person_name" )        
        el-table-column(prop="handle_resp" label="回复内容" width="140" key="handle_resp" )
        el-table-column(v-if="user.role == 3 ? true : activeName==='six'" prop="over_resp" label="完结回复" width="140" key="over_resp" )
        el-table-column(prop="status" label="单据状态" width="80" key="status" )
          template(slot-scope="scope")
            span {{scope.row.status==1?'确认中':''}}
            span {{scope.row.status==2?'处理中':''}}
            span {{scope.row.status==3?'验收中':''}}
            span {{scope.row.status==4?'评价中':''}}
            span {{scope.row.status==5?'处理完毕':''}}
            span {{scope.row.status==6?'终止处理':''}}
        el-table-column(label="操作" :width="activeName=='three'? 250: activeName=='four'? 200 : 280")
          template(slot-scope="scope")
            el-button(v-if="user.role == 3 ? true : ops.indexOf('confirm') > -1" v-show="activeName=='first'" size="mini" type="primary" plain @click="goto('/purchase/purchase_after_sales_edit/'+scope.row.id)") 审批
            el-button(v-if="user.role == 3 ? true : ops.indexOf('edit') > -1" v-show="activeName=='first'" size="mini" type="primary" plain @click="finish(scope.row)") 完结处理
            el-button(v-if="user.role == 3 ? true : ops.indexOf('change') > -1" v-show="activeName=='first'" size="mini" type="primary" plain @click="setSourceBuyOrg(scope.row)" ) 变更组织
            el-button(v-if="user.role == 3 ? true : ops.indexOf('details') > -1" v-show="activeName!='first'" size="mini" type="primary" plain @click="goto('/purchase/purchase_after_sales_detail/'+scope.row.id)") 详情
            el-button(v-if="user.role == 3 ? true : ops.indexOf('edit') > -1" v-show="activeName=='three'" size="mini" type="primary" plain @click="agree(scope.row)") 同意
            el-button(v-if="user.role == 3 ? true : ops.indexOf('edit') > -1"  v-show="activeName=='four'" size="mini" type="primary" plain @click="setScore(scope.row)") 评分
      el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total,sizes, prev, pager, next, jumper" :total="count" background)
      el-dialog.dialog(title="变更采购组织" :visible.sync="dialogFormBuyOrg" width="380px" :show-close="false" :destroy-on-close="true" :append-to-body="true" :close-on-press-escape="false" :close-on-click-modal="true")
        el-form(:model="buyOrg" ref="buyOrg" size="mini" :rules="rules")
          el-form-item(prop="pk_org")
            el-select.w-100(v-model="buyOrg" filterable placeholder="请选择公司" value-key="pk_org")
              el-option(v-for="item in purchase_org" :key="item.pk_org" :label="item.name" :value="item")
        div(slot="footer" class="dialog-footer")
          el-button(size="mini" @click="dialogFormBuyOrg = false" :loading="loading") 取 消
          el-button(size="mini" type="primary" @click="submitFormBuyOrg" :loading="loading") 确 定
      el-dialog.dialog(title="打分" :visible.sync="scoreForm" width="380px" :show-close="false" :destroy-on-close="true" :append-to-body="true" :close-on-press-escape="false" :close-on-click-modal="true")
        el-form(:model="formBuyOrg" ref="buyOrg" size="mini" :rules="rules")
          el-form-item(label="打分" prop="sd_resp")
            el-radio-group(v-model="formBuyOrg.sd_resp" @change="changeType")
              el-radio(label="非常满意") 非常满意
              el-radio(label="满意") 满意
              el-radio(label="不满意") 不满意
        div(slot="footer" class="dialog-footer")
          el-button(size="mini" @click="scoreForm = false" :loading="loading") 取 消
          el-button(size="mini" type="primary" @click="submitScore" :loading="loading") 确 定
      el-dialog.dialog(title="完结回复" :visible.sync="dialogFormFinish" width="380px" :show-close="false" :destroy-on-close="true" :append-to-body="true" :close-on-press-escape="false" :close-on-click-modal="true")
        el-form(:model="formBuyOrg" ref="buyOrg" size="mini" label-width="100px" :rules="rules")
          el-form-item(label="完结回复" prop="handle_req")
            el-input(v-model="formBuyOrg.handle_req")
        div(slot="footer" class="dialog-footer")
          el-button(size="mini" @click="dialogFormFinish=false") 取 消
          el-button(size="mini" type="primary" @click="submitFinish") 确 定
</template>
<script>


export default {
  data() {
    return {
      flag: true,
      h: "",
      loading: false,
      activeName: "first",
      list: {
        mater_code: null,
        mater_name: null,
        code: null,
        supplier: null,
        buy_org: null,
        stock_org: null,
        user: null,
        page_num: 1,
        page_size: 10,
        status: 1
      },
      person: [],
      loadingPerson: false,
      dialogFormBuyPerson: false,
      count: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
      count5: 0,
      count6: 0,
      count7: 0,
      list1: {
        status: 1,
        page_num: 1,
        page_size: 10,
      },
      list2: {
        status: 2,
        page_num: 1,
        page_size: 10,
      },
      list3: {
        status: 3,
        page_num: 1,
        page_size: 10,
      },
      list4: {
        status: 4,
        page_num: 1,
        page_size: 10,
      },
      list5: {
        status: 5,
        page_num: 1,
        page_size: 10,
      },
      list6: {
        status: 6,
        page_num: 1,
        page_size: 10,
      },
      list7: {
        status: null,
        page_num: 1,
        page_size: 10,
      },
      time: "",
      loadingSupply: false,
      data: [],
      supply: [],
      approve: [],
      dialogVisible: false,
      dialogFormBuyOrg: false,
      scoreForm: false,
      dialogFormFinish: false,
      formBuyOrg: {},
      rules: {
        pk_org: [{ required: true, message: "请选择公司", trigger: "change" }],
        sd_resp: [
          { required: true, message: '请打分', trigger: 'change' }
        ],
        handle_req: [
          { required: true, message: '请填写完结回复', trigger: 'change' }
        ],
      },
    };
  },
  computed: {
    buyOrg: {
      get: function () {
        return {
          pk_org: this.formBuyOrg.buy_org,
        }
      },
      set: function (val) {
        this.formBuyOrg.buy_org = val.pk_org;
        this.formBuyOrg.buy_org_code = val.code;
        this.formBuyOrg.buy_org_name = val.name;
      }
    },
  },
  methods: {
    async exportData() {
      this.loading = true;
      await this.$api.purchase_after_sales.getBlob(this.list);
      this.loading = false;
    },
    async getApprove(type, id) {
      this.loading = true;
      let res = await this.$api.global.getApprove(type, id);
      this.loading = false;
      this.dialogVisible = true;
      if (res) {
        this.approve = res.data;
      } else {
        this.approve = [];
      }
    },
    async getPersonList(query) {
      if (!query) {
        return false;
      }
      this.loadingPerson = true;
      let res = await this.$api.global.personList({
        key_name: query,
        page_num: 1,
        page_size: 100,
      });
      this.loadingPerson = false;
      if (res) {
        this.person = res.data;
      }
    },
    setSourceBuyPerson() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要操作的数据",
          type: "error",
        });
        return false;
      }
      this.dialogFormBuyPerson = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    clear() {
      this.list.code = null;
      this.list.user = null;
      this.list.mater_name = null;
      this.list.mater_code = null;
      this.list.supplier = null;
      this.list.stock_org = null;
      this.list.buy_org = null;
    },
    async getSupplyList(query) {
      if (!query) {
        return false;
      }
      localStorage.setItem("PurchaseAfterSales_query", query);
      this.loadingSupply = true;
      let res = await this.$api.supplier.getotherList({
        key_name: query,
        page_num: 1,
        page_size: 100,
        no_check: 1,
        checkstatus: 3,
      });
      this.loadingSupply = false;
      if (res) {
        this.supply = res.data;
      }
    },
    search() {
      this.list.page_num = 1;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleTabClick(tab) {
      let data = this.list;
      if (tab.name == "first") {
        data.page_size = this.list1.page_size;
        data.page_num = this.list1.page_num;
        data.status = this.list1.status;
      } else if (tab.name == "second") {
        data.page_size = this.list2.page_size;
        data.page_num = this.list2.page_num;
        data.status = this.list2.status;
      } else if (tab.name == "three") {
        data.page_size = this.list3.page_size;
        data.page_num = this.list3.page_num;
        data.status = this.list3.status;
      } else if (tab.name == "four") {
        data.page_size = this.list4.page_size;
        data.page_num = this.list4.page_num;
        data.status = this.list4.status;
      } else if (tab.name == "five") {
        data.page_size = this.list5.page_size;
        data.page_num = this.list5.page_num;
        data.status = this.list5.status;
      } else if (tab.name == "six") {
        data.page_size = this.list6.page_size;
        data.page_num = this.list6.page_num;
        data.status = this.list6.status;
      } else if (tab.name == "seven") {
        data.page_size = this.list7.page_size;
        data.page_num = this.list7.page_num;
        data.status = this.list7.status;
      }
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    async getList() {
      this.loading = true;
      let pam = {}
      for (let i in this.list) {
        if (this.list[i] !== '') {
          pam[i] = this.list[i]
        }
      }
      let res = await this.$api.purchase_after_sales.getList(pam);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count1 = res.count1 ? res.count1 : 0;
        this.count2 = res.count2 ? res.count2 : 0;
        this.count3 = res.count3 ? res.count3 : 0;
        this.count4 = res.count4 ? res.count4 : 0;
        this.count5 = res.count5 ? res.count5 : 0;
        this.count6 = res.count6 ? res.count6 : 0;
        this.count7 = res.count ? res.count : 0;
        switch (this.activeName) {
          case "first":
            this.count = this.count1;
            break;
          case "second":
            this.count = this.count2;
            break;
          case "three":
            this.count = this.count3;
            break;
          case "four":
            this.count = this.count4;
            break;
          case "five":
            this.count = this.count5;
            break;
          case "six":
            this.count = this.count6;
            break;
          case "seven":
            this.count = this.count7;
            break;
          default:
            break;
        }
      }
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    setSourceBuyOrg(row) {
      this.formBuyOrg = row;
      this.dialogFormBuyOrg = true;
    },
    setScore(row) {
      this.formBuyOrg = row;
      this.scoreForm = true;
    },
    submitFormBuyOrg() {
      this.$refs["buyOrg"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let res = await this.$api.purchase_after_sales.listEdit(this.formBuyOrg);
          this.loading = false;
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.dialogFormBuyOrg = false
            this.getList();
          }
        } else {
          return false;
        }
      });
    },
    submitScore() {
      this.$refs["buyOrg"].validate(async (valid) => {
        if (valid) {
          this.formBuyOrg.status = 5
          this.loading = true;
          let res = await this.$api.purchase_after_sales.listEdit(this.formBuyOrg);
          this.loading = false;
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.scoreForm = false
            this.getList();
          }
        } else {
          return false;
        }
      });
    },
    submitFinish() {
      this.$refs["buyOrg"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let data = this.formBuyOrg;
          data.status = 6;
          let res = await this.$api.purchase_after_sales.listEdit(data);
          this.loading = false;
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.dialogFormFinish = false;
            this.getList();
          }
        } else {
          return false;
        }
      });
    },

    async finish(row) {
      this.formBuyOrg = row;
      this.dialogFormFinish = true
    },
    async agree(row) {
      this.$confirm("此操作将同意该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          let data = row;
          data.status = 4;
          let res = await this.$api.purchase_after_sales.listEdit(data);
          this.loading = false;
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.getList();
          }
        })
        .catch(() => { });
    },
    initList() {
      let data = this.$route.query;
      if (JSON.stringify(data) != "{}") {
        this.list = this.$utils.cloneDeep(data);
        this.list.status = parseInt(this.list.status)
          ? parseInt(this.list.status)
          : this.list.status;
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
              ? parseInt(data.page_size)
              : this.page_sizes[0];
        }
        let status = this.list.status;
        switch (parseInt(status)) {
          case 1:
            this.activeName = "first";
            break;
          case 2:
            this.activeName = "second";
            break;
          case 3:
            this.activeName = "three";
            break;
          case 4:
            this.activeName = "four";
            break;
          case 5:
            this.activeName = "five";
            break;
          case 6:
            this.activeName = "six";
            break;
          default:
            this.list.status = null;
            this.activeName = "seven";
            break;
        }
        switch (this.activeName) {
          case "first":
            this.list1.page_size = this.list.page_size;
            this.list1.page_num = this.list.page_num;
            break;
          case "second":
            this.list2.page_size = this.list.page_size;
            this.list2.page_num = this.list.page_num;
            break;
          case "three":
            this.list3.page_size = this.list.page_size;
            this.list3.page_num = this.list.page_num;
            break;
          case "four":
            this.list4.page_size = this.list.page_size;
            this.list4.page_num = this.list.page_num;
            break;
          case "five":
            this.list5.page_size = this.list.page_size;
            this.list5.page_num = this.list.page_num;
            break;
          case "six":
            this.list6.page_size = this.list.page_size;
            this.list6.page_num = this.list.page_num;
            break;
          case "seven":
            this.list7.page_size = this.list.page_size;
            this.list7.page_num = this.list.page_num;
            break;
          default:
            break;
        }
        this.$router.push({
          path: this.$route.path,
          hash: "#" + this.activeName,
          query: this.list,
        });
      }
    },
    init() {
      this.activeName = this.$route.hash
        ? this.$route.hash.split("#")[1]
        : "first";
      this.initList();
      this.getList();
    },
  },
  mounted() {
    if (this.$store.state.token && this.$store.state.purchase_org == false)
      this.getPurchaseOrg();
    if (this.$store.state.token && this.$store.state.stock_org == false)
      this.getStockOrg();
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() { },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>
